export const ACTION_TYPES = {
    ADD_EMPLOYEE: "ADD_EMPLOYEE",
    EDIT_EMPLOYEE: "EDIT_EMPLOYEE",
    BLOCK_ORDER: "BLOCK_ORDER",
    CANCEL_ORDER: "CANCEL_ORDER",
    BLOCK_EMPLOYEE: "BLOCK_EMPLOYEE",
    DELETE_EMPLOYEE: "DELETE_EMPLOYEE",
    SCAN_QR: "SCAN_QR",
    DELETE_ORDER: "DELETE_ORDER"
}

